import AllForm from '../../../Stateless/Form';
import { JSX } from 'react';

import { DateTimeField } from './DateTimeField';
import { bannerValidationSchema } from './BannerSchemaValidation';
import ImageUploadField from '../../../Stateless/ImageUploadField';
import CustomButtons from '../../../Stateless/CustomButtons';
import { useBannerFormSubmit } from './Hooks/BannerOnsubmit';
import { useAtom } from 'jotai';
import { bannerAtom } from './BannerSettingsTable';

// Wrapper to adapt field/form to ImageUploadField's props
const ImageUploadFieldWrapper = (props: { field: any; form: any }) => (
  <ImageUploadField
    name={props.field.name}
    label="Banner Image"
    // You can add more props here if needed
  />
);

const AddBannerForm = ({ onCancel }: { onCancel: () => void }) => {
  const [bannerData] = useAtom(bannerAtom);
  const { onSubmit, EditBannerLoading, createBannerLoading } =
    useBannerFormSubmit({
      bannerData,
      onCancel,
    });
  const initialValues = {
    imageUrl: bannerData?.imageUrl ?? undefined,
    storeType: bannerData?.storeType ?? '',
    imageTextEnglish: bannerData?.imageTextEnglish ?? '',
    imageTextArabic: bannerData?.imageTextArabic ?? '',
    redirectUrl: bannerData?.redirectUrl ?? '',
    buttonTextEnglish: bannerData?.buttonTextEnglish ?? '',
    buttonTextInArabic: bannerData?.buttonTextInArabic ?? '',
    bannerStartTime: bannerData?.bannerStartTime || new Date().toISOString(),
    bannerEndTime: bannerData?.bannerEndTime || new Date().toISOString(),
  };

  return (
    <>
      {AllForm({
        initialValues,
        validationSchema: bannerValidationSchema,
        onSubmit,
        fields: [
          {
            name: 'imageUrl',
            label: 'Image URL:',
            type: 'file',
            isRequired: true,
            component: ImageUploadFieldWrapper,
          },
          {
            name: 'storeType',
            label: 'Store Type',
            type: 'radio',
            radioOptions: ['Restaurant', 'GroceryStore', 'PharmacyStore'],
            isRequired: true,
          },
          {
            name: 'imageTextEnglish',
            label: 'Image Text English:',
            type: 'text',
            isRequired: true,
          },
          {
            name: 'imageTextArabic',
            label: 'Image Text Arabic:',
            type: 'text',
          },
          {
            name: 'redirectUrl',
            label: 'Redirect Url:',
            type: 'text',
          },
          {
            name: 'buttonTextEnglish',
            label: 'Button Text English:',
            type: 'text',
          },
          {
            name: 'buttonTextInArabic',
            label: 'Button Text Arabic:',
            type: 'text',
          },
          {
            name: 'bannerStartTime',
            label: 'Start Time:',
            isRequired: true,
            type: 'custom',
            relatedFieldToClearError: 'bannerEndTime',
            component: DateTimeField as (props: {
              field: any;
              form: any;
            }) => JSX.Element,
          },
          {
            name: 'bannerEndTime',
            label: 'End Time:',
            isRequired: true,
            type: 'custom',
            relatedFieldToClearError: 'bannerStartTime',
            component: DateTimeField as (props: {
              field: any;
              form: any;
            }) => JSX.Element,
          },
        ],
        customButton: (formikProps: any) => (
          <CustomButtons
            formikProps={formikProps}
            isLoading={createBannerLoading || EditBannerLoading}
            isEditing={!!bannerData}
            onCancel={onCancel}
          />
        ),
      })()}
      ;
    </>
  );
};

export default AddBannerForm;
